import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import HomePage from '@/views/HomePage.vue'
import NavigationPortal from '@/views/NavigationPortal.vue'
import ProductCenter from '@/views/ProductCenter.vue'
import ApplicationCases from '@/views/ApplicationCases.vue'
import ConfigAssistant from '@/views/ConfigAssistant.vue'
import AboutUs from '@/views/AboutUs.vue'
import JoinUs from '@/views/JoinUs.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'homePage',
        component: HomePage
      },
      {
        path: '/navigation',
        name: 'navigation',
        component: NavigationPortal
      },
      {
        path: '/products',
        name: 'products',
        component: ProductCenter
      },
      {
        path: '/cases',
        name: 'cases',
        component: ApplicationCases
      },
      {
        path: '/config-assistant',
        name: 'configAssistant',
        component: ConfigAssistant
      },
      {
        path: '/about',
        name: 'about',
        component: AboutUs
      },
      {
        path: '/join-us',
        name: 'joinUs',
        component: JoinUs
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
